module.exports = __webpack_public_path__ + "img/europa.801c43bd.png";